import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Alert, AlertTitle } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';

function RandomCode() {
  const [randomCode, setRandomCode] = useState(null);

  // Function to generate a random 4-digit code
  const generateRandomCode = () => {
    return Math.floor(1000 + Math.random() * 9000);
  };

  return (
    <div className="container mt-4">
      <h1> Form</h1>
      <Formik
        initialValues={{ image: '', id: '' }}
        validationSchema={Yup.object({
          id: Yup.string()
            .required('Required')
            .matches(/^[0-9]{6}$/, 'Must be exactly 6 digits'),
          image: Yup.mixed().required('Required'),
        })}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            // After form submission, generate a random code
            const code = generateRandomCode();
            setRandomCode(code);
            setSubmitting(false);
          }, 400);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="mb-3">
              <label htmlFor="image" className="form-label">Upload Image</label>
              <Field name="image" type="file" className="form-control" />
              <ErrorMessage name="image" component="div" className="text-danger" />
            </div>
            <div className="mb-3">
              <label htmlFor="id" className="form-label">Enter ID (6 digits)</label>
              <Field name="id" type="text" className="form-control" />
              <ErrorMessage name="id" component="div" className="text-danger" />
            </div>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              Submit
            </button>
          </Form>
        )}
      </Formik>
      {/* Material-UI Alert to display the random code */}
      {randomCode && (
        <Alert severity="success" className="mt-4">
          <AlertTitle>Submit Success!</AlertTitle>
          Your code is: {randomCode}
        </Alert>
      )}
    </div>
  );
}

export default RandomCode;
